import Component from 'vue-class-component'
import UrlEditor from '../dialog/UrlEditor.vue'
import ComponentVue from './Component'
import { UrlData } from '../../store/editor/components/state'
import InteractableComponent from './InteractableComponent'
import { Actions } from '../../store/editor/components/helpers'
import { LinkType, OembedLink } from '../dialog/UrlEditorInterface'
import { GetOembedResponse } from '../../api/iframely/core'
import ChamomileUrl from '../../misc/chamomile-url'

const MAX_DESCRIPTION_LENGTH = 90

@Component({
  components: {
    'url-editor': UrlEditor
  }
})
export default class UrlVue extends ComponentVue<UrlData> {
  isEditorVisible: boolean = false
  private interactable: InteractableComponent // D&Dに使う

  get oembedLink(): OembedLink {
    return this.componentData.oembedLink
  }

  set oembedLink(link: OembedLink) {
    this.save(Object.assign({}, this.componentData, <UrlData>{
      oembedLink: link
    }))
  }

  get linkType(): LinkType {
    return this.oembedLink.linkType
  }

  get url(): string {
    return this.oembedLink.url
  }

  get chamomileUrl(): ChamomileUrl {
    return new ChamomileUrl(this.url)
  }

  get domain(): string {
    return this.chamomileUrl.domain
  }

  get oembedResponse(): GetOembedResponse {
    return this.oembedLink.response
  }

  get fileName(): string {
    return this.chamomileUrl.decodedFileName
  }

  get title(): string {
    return this.oembedResponse.title || this.fileName
  }

  get description(): string {
    const description = this.oembedResponse.description || ''
    if (description.length > MAX_DESCRIPTION_LENGTH) {
      return description.substring(0, MAX_DESCRIPTION_LENGTH) + '...'
    }
    return description
  }

  get thumbnailUrl(): string {
    return this.oembedLink.thumbnail || ''
  }

  get html(): string {
    return this.oembedResponse.html || ''
  }

  get isMaskVisible(): boolean {
    return !this.hasFocus
  }

  mounted(): void {
    this.enableFocus()
    this.interactable = new InteractableComponent(this.$el, this.$store)
    this.interactable.draggable({
      handle: '.url-content__handle',
      extraTransform: 'scale(.7)'
    })
    this.interactable.droppable()
      .onDropTo((event) => {
        Actions.move(this.$store, {
          component: event.dropping,
          destination: this.componentData,
          direction: event.direction
        })
      })
  }

  destroyed(): void {
    this.interactable.destroy()
  }

  showEditor(): void {
    this.isEditorVisible = true
  }

  hideEditor(): void {
    this.isEditorVisible = false
  }

  saveContent(link: OembedLink): void {
    this.oembedLink = link
    this.hideEditor()
  }

  trackClose(): void {
    this.hideEditor()
  }

  trackInputUrl(): void {
  }
}
